var tag = document.createElement('script');

tag.src = 'https://www.youtube.com/iframe_api';
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// video modal
var $videoModal = $('#video-modal.modal');

// YT player object
var player;
var currVideoId;
var currHref = window.location.href; // Add missing variable
var inlinePlayers = {};
var isYouTubeApiReady = false;
var ytVars;
var ytLang;
var ytLoadPolicy = 1;

/** Same markup as OptimizelyVideoBlock (play/pause swap). */
var youTubeInlinePauseSvg =
    '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">' +
    '<path d="M2 1V14.3333" stroke="#00CC99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '<path d="M10 1V14.3333" stroke="#00CC99" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
    '</svg>';
var youTubeInlinePlaySvg =
    '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path d="M5 3L12 8L5 13V3Z" fill="currentColor"/>' +
    '</svg>';

ytLang = $('body').attr('class').substring(0, 2);
if (ytLang == 'en') {
    ytLoadPolicy = 0;
}
ytVars = {
    modestbranding: 1,
    cc_load_policy: ytLoadPolicy,
    cc_lang_pref: ytLang,
    hl: ytLang,
    mute: 1,
};

function onYouTubeIframeAPIReady() {
    isYouTubeApiReady = true;
    initYouTubeInlinePlayers();
}

function onPlayerReady(event) {}

function onPlayerStateChange(event) {
    var title = event.target.getVideoData().title;
    var category = 'Video';
    var label = 'Video: ' + title + ' - URL: ' + currHref;

    if (event.data == YT.PlayerState.PAUSED) {
        ga('send', 'event', category + ' - Paused', title, label);
    }
    if (event.data == YT.PlayerState.PLAYING) {
        ga('send', 'event', category + ' - Play', title, label);
    }
    if (event.data == YT.PlayerState.ENDED) {
        ga('send', 'event', category + ' - Watch to End', title, label);
    }
    if (event.data == YT.PlayerState.CUED) {
        ga('send', 'event', category + ' - Cued', title, label);
    }
}

function playVideo(id) {
    currVideoId = id;
    if (player) {
        player.loadVideoById(id, 0);
    } else {
        player = new YT.Player('modal-player', {
            playerVars: ytVars,
            videoId: id,
            events: {
                onReady: function () {
                    player.loadVideoById(currVideoId);
                },
                onStateChange: onPlayerStateChange,
            },
        });
    }
}

function loadVideo(videoId) {
    if (!videoId) return;
    $videoModal.modal();
    playVideo(videoId);
}

function pauseVideo() {
    if (player) {
        try {
            player.pauseVideo();
        } catch (err) {}
    }
}

function getInlinePlayPauseButton($iframe) {
    return $iframe.closest('.youtube-inline-container').find('.youtube-block__play-pause-btn');
}

function syncInlinePlayPauseButton(ytPlayer) {
    if (!ytPlayer || !ytPlayer.getIframe) {
        return;
    }

    var iframe = ytPlayer.getIframe();
    var $btn = getInlinePlayPauseButton($(iframe));
    if (!$btn.length) {
        return;
    }

    var state = ytPlayer.getPlayerState();
    var isPaused = state === YT.PlayerState.PAUSED || state === YT.PlayerState.ENDED;

    if (isPaused) {
        $btn.html(youTubeInlinePlaySvg).attr({ 'aria-label': 'Play video', title: 'Play video' });
    } else {
        $btn.html(youTubeInlinePauseSvg).attr({ 'aria-label': 'Pause video', title: 'Pause video' });
    }
}

function initYouTubeInlinePlayers() {
    if (!isYouTubeApiReady || typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
        return;
    }
    if ($('body').hasClass('epi-editMode')) {
        return;
    }

    $('.youtube-inline-iframe').each(function () {
        var iframeId = this.id;
        if (!iframeId || inlinePlayers[iframeId]) {
            return;
        }

        inlinePlayers[iframeId] = new YT.Player(iframeId, {
            events: {
                onReady: function (event) {
                    syncInlinePlayPauseButton(event.target);
                },
                onStateChange: function (event) {
                    syncInlinePlayPauseButton(event.target);
                },
            },
        });
    });
}

jQueryOnReady(function initYouTubeInlineOnReady() {
    if ($('body').hasClass('epi-editMode')) {
        return;
    }
    initYouTubeInlinePlayers();
});

$('document').ready(function () {
    $(document.body).on('click', 'a.is-video', function (e) {
        e.preventDefault();
        var videoId = $(this).attr('data-video-id');
        loadVideo(videoId);
    });

    $(document).on('click', '.youtube-block .youtube-block__play-pause-btn', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $btn = $(this);
        var $container = $btn.closest('.youtube-inline-container');
        var iframeId = $container.find('.youtube-inline-iframe').attr('id');
        if (!iframeId || !inlinePlayers[iframeId]) {
            return;
        }

        var inlinePlayer = inlinePlayers[iframeId];
        var state = inlinePlayer.getPlayerState();
        if (state === YT.PlayerState.PLAYING) {
            inlinePlayer.pauseVideo();
        } else {
            inlinePlayer.playVideo();
        }
    });

    $videoModal.on('hidden.bs.modal', function (e) {
        if (player) {
            try {
                player.destroy();
            } catch (err) {}
            player = null;
        }
        var $container = $('#video-modal').find('#modal-player');
        if ($container.length) {
            $container.replaceWith('<div id="modal-player"></div>');
        }
    });

    var $worldMapModal = $('.world-map-modal.modal');
    $worldMapModal.on('shown.bs.modal', function (e) {
        var target = $worldMapModal.find('[data-youtubeid]');
        if (target.length) {
            player = new YT.Player('world-map-player', {
                playerVars: ytVars,
                videoId: target.attr('data-youtubeid'),
                events: {
                    onReady: function () {},
                    onStateChange: onPlayerStateChange,
                },
            });
        }
    });
    $worldMapModal.on('hidden.bs.modal', function (e) {
        $('#world-map-player').replaceWith('<div id="world-map-player"></div>');
    });

    initYouTubeInlinePlayers();
});
